export default __webpack_public_path__ + "static/media/vccircle.cd781b71.jpg";